import { ConvertPriceToString } from "../../Helpers/CustomConverter"
import { useAuth } from "../../Providers/AuthProvider"
import { useCustomer } from "../../Providers/CustomerProvider"

const CustomerInformationMobile = () => {
    const { authState } = useAuth()
    const { creditInfo } = useCustomer()

    return (
        <div className="d-flex flex-column" style={{ fontSize: '16px' }}>
            {authState.siteId && authState.user && <span className="mt-1">{`Limit kredytowy: ${ConvertPriceToString(creditInfo.remainCredit)} / ${ConvertPriceToString(creditInfo.grantCredit)}`}</span>}
        </div>
    )
}

export default CustomerInformationMobile